// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '대한뉴팜',
  targetSheetName: 'DHNP',
  headerRowIndex: 11,
  headerRowCount: 1,
  dataStartRowIndex: 13,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '보험약가',
    commissionRate: '수수료',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '품목군',
    '생산 구분',
    '자사 생동',
    '계열',
    '제품명',
    '성분명',
    '보험코드',
    '보험약가',
    '포장단위',
    '수수료',
    '비고',
    '대조약',
  ],
});
